<ui-tag
  *ngIf="confidenceType !== 'emoji'"
  [class]="emojiClass + ' confidenceType-' + confidenceType"
  [uiColor]="color"
  [uiTooltipTitle]="!disableTooltip ? confidenceLevelTooltip : undefined"
  data-test-id="confidence-label"
  uiMode="default"
  role="button"
  ui-tooltip>
  {{ confidenceName }}
</ui-tag>
<span
  *ngIf="confidenceType === 'emoji'"
  [style.color]="color"
  [style.backgroundColor]="color"
  [class]="'confidence-badge ' + emojiClass + ' confidenceType-emoji'"
  [uiTooltipTitle]="!disableTooltip ? confidenceLevelTooltip : undefined"
  ui-tooltip
  data-test-id="confidence-label">
  {{ confidenceName }}
</span>
